import * as React from "react";
import { useDeleteRoleMutation } from "../../services/appln";
import strings from "../../config/localization";
import DeletePanel from "../../components/CustomDelete/DeletePanel";

export default function RoleDelete(props: any): any {
  return (
    <DeletePanel
      deleteMutation={useDeleteRoleMutation}
      deleteArgs={{ roleId: props.roleId }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deleteRoleTitle}
      confirmationDialogMsg={strings.deleteRoleConfirmation}
      errorDialogTitle={strings.roleDeleteFailedTitle}
      errorDialogMsg={strings.roleDeleteFailedMsg}
    />
  );
}
